export default __webpack_public_path__ + "static/media/roboto-v20-latin-900italic.a4f5514c.eot";